
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/condominios",
      function () {
        return require("private-next-pages/condominios/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/condominios"])
      });
    }
  